import React, { memo, useEffect } from 'react';
import { Blok } from '../../../../../../interfaces/Blok.interface';

interface LiveChatBlokProps extends Blok {
  label: string;
  engagement_id: string;
}

interface LiveChatProps {
  blok: LiveChatBlokProps;
}

declare global {
  interface Window {
    lpTag: any;
  }
}

const LiveChat: React.FC<LiveChatProps> = ({ blok }) => {
  const { label, engagement_id } = blok;

  const handleLiveChat = (e: any) => {
    e.preventDefault();
    const chatButton: HTMLElement = document.querySelector(
      '[data-lp-event="click"]'
    ) as HTMLElement;

    if (!chatButton) return null;

    chatButton?.click();
  };

  useEffect(() => {
    const chatContainer = document.querySelector('.chat-cont');

    const handleClick = (event: any) => {
      if (event.target.tagName === 'A') {
        event.preventDefault();
      }
    };

    if (!chatContainer) return;

    // Add click event listener to the chat container
    chatContainer.addEventListener('click', handleClick);

    // // Clean up the event listener when the component unmounts
    return () => {
      chatContainer.removeEventListener('click', handleClick);
    };
  }, []);

  if (typeof window !== 'undefined') {
    if (window.lpTag?.newPage) {
      window.lpTag.newPage(window.location.href, {
        section: [],
        sdes: [],
        taglets: {
          rendererStub: {
            divIdsToKeep: {
              divId: true,
            },
          },
        },
      });
    }
  }

  return (
    <div>
      <button
        className="w-full flex items-center justify-between p-4 my-4 bg-stepper/stepper-bg hover:bg-stepper/stepper-active-bg rounded-[6px] transition-all duration-300 group"
        onClick={handleLiveChat}
      >
        <div className="flex items-center justify-start gap-x-4">
          <div
            className="w-10 h-10 rounded-full bg-no-repeat"
            style={{
              background: `url(/svgs/move-specialist-live-chat-contact-icon.svg)`,
            }}
          ></div>
          <p className="text-text/body group-hover:text-system/white transition-all duration-300">
            {label}
          </p>
        </div>
        <div
          className="bg-no-repeat w-6 h-6 bg-text/body-accent group-hover:bg-system/white transition-all duration-300"
          style={{
            WebkitMaskImage: "url('/svgs/right-arrow.svg')",
            maskImage: "url('/svgs/right-arrow.svg')",
          }}
        />
      </button>
      <div style={{ display: 'none' }}>
        <div id={engagement_id} className="chat-cont"></div>
      </div>
    </div>
  );
};

export default memo(LiveChat);
